import { render, staticRenderFns } from "./VariableCompensationPayments.vue?vue&type=template&id=fb34f3f4&scoped=true"
import script from "./VariableCompensationPayments.vue?vue&type=script&lang=js"
export * from "./VariableCompensationPayments.vue?vue&type=script&lang=js"
import style0 from "./VariableCompensationPayments.vue?vue&type=style&index=0&id=fb34f3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb34f3f4",
  null
  
)

export default component.exports